import { GYPSUM } from 'HubStyleTokens/colors';
import { ECLIPSE } from 'developer-docs-shared-components/config/cssConstants';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { getPathNames } from '../config/nav/navUtils';
import UIRouterNavLink from 'ui-addon-react-router-dom/UIRouterNavLink';
import ResponsiveRenderer from 'developer-docs-shared-components/components/ResponsiveRenderer';
import UIList from 'UIComponents/list/UIList';
import { getLocalizedBadge } from '../utils/localization';
import { NESTED_NAV_ACTIVE_LINK_CLASSNAME, getSharedPillLinkStyles } from '../utils/css';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Nav = styled.nav.withConfig({
  displayName: "PrimaryNavSubmenu__Nav",
  componentId: "xw7sx9-0"
})(["background:", ";padding:5px 40px;", "{padding-left:308px;}li{margin:0 1vw;&:first-child{margin-left:0;}", "{margin-left:32px;margin-right:32px;}}a{", " color:", ";&:hover,&:focus{color:", ";}&.", "{color:", ";background:", ";font-weight:600;}}"], ECLIPSE, mediaQueries.aboveLaptop, mediaQueries.aboveLaptop, getSharedPillLinkStyles(GYPSUM), GYPSUM, GYPSUM, NESTED_NAV_ACTIVE_LINK_CLASSNAME, ECLIPSE, GYPSUM);

/**
 * Submenu of SecondaryNavConfig items that shows in a blue row beneath the
 * primary nav when a primary item is open. Desktop only.
 */
const PrimaryNavSubmenu = ({
  primaryNavConfig
}) => {
  const {
    pathname
  } = useLocation();
  const {
    primaryDir
  } = getPathNames(pathname);
  const matchingNavConfig = primaryNavConfig.find(({
    baseDirectory
  }) => baseDirectory === `/${primaryDir}`);
  if (!matchingNavConfig) {
    return null;
  }
  const secondaryNavConfigs = matchingNavConfig.getSecondaryNavConfigs();
  if (secondaryNavConfigs.length === 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(ResponsiveRenderer, {
    renderDesktop: () => /*#__PURE__*/_jsx(Nav, {
      "data-test-id": "primary-nav-submenu",
      "aria-label": matchingNavConfig.label,
      children: /*#__PURE__*/_jsx(UIList, {
        inline: true,
        childClassName: "p-all-0",
        children: secondaryNavConfigs.map(fn => {
          const {
            commonPath,
            sectionLabel,
            badge
          } = fn();
          return /*#__PURE__*/_jsxs(UIRouterNavLink, {
            activeClassName: NESTED_NAV_ACTIVE_LINK_CLASSNAME,
            exact: false,
            to: commonPath,
            children: [sectionLabel, getLocalizedBadge(badge === 'BETA' ? 'BETA_SUFFIX' : badge)]
          }, commonPath);
        })
      })
    }),
    renderMobile: () => null
  });
};
export default PrimaryNavSubmenu;